import { reactive } from 'vue';

export const criarCultura = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdcultura: 0,
        nmcultura: '',
        ativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
};